import routerOptions0 from "/home/runner/work/mfx-framework/mfx-framework/node_modules/.pnpm/nuxt@3.5.3_@types+node@18.14.6_eslint@8.40.0_typescript@5.1.3_vue-tsc@1.8.3/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}